import "../Assets/css/firstpage.css";//E:\Projects\Office\sea_showcase_nextui\src\view\pages\products\ProductCategory.js
import { useEffect, useState } from "react";
import logo from "../Assets/image/logo.png";
import { Link } from "react-router-dom";
import Bar1 from "../components/navigationbar/navigationbar1";
import supportgirl from '../Assets/image/supportgirls.png';
import imageData from './pages/imagedata';
import PointerGradientText from "../components/PointerGradientText";
// import { TextFade } from '../../src/components/fade/'; 
import SecondAnimate from "./pages/secondanimation/secondanimation";
import Footer from "./pages/footer/footer";
import ProductCategory from "./pages/products/ProductCategory";
import RevealBlurFX from "../components/Effect/RevealBlurFX";
import WhyUs from "./pages/WhyUs/whyus";
import { Helmet } from "react-helmet";
import FrontPage from "./pages/FrontpageBanner/page";

function FPage() {

    ////////////////  background image slide start ////////////////
    const [currentIndex, setCurrentIndex] = useState(1);
    const [isAnimating, setIsAnimating] = useState(true);
    const totalImages = imageData.length;
    const extendedImageData = [
        imageData[totalImages - 1], // Clone last
        ...imageData,
        imageData[0], // Clone first
    ];
    useEffect(() => {
        let interval;

        const startInterval = () => {
            interval = setInterval(() => {
                setIsAnimating(true);
                setCurrentIndex((prevIndex) => prevIndex + 1);
            }, 8000);
        };

        const stopInterval = () => clearInterval(interval);

        // Start interval when tab is visible
        const handleVisibilityChange = () => {
            if (document.hidden) {
                stopInterval();
            } else {
                startInterval();
            }
        };

        startInterval(); // Start interval initially
        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            stopInterval();
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    const handleTransitionEndd = () => {
        if (currentIndex === 0) {
            setIsAnimating(false);
            setTimeout(() => setCurrentIndex(totalImages), 0);
        } else if (currentIndex === totalImages + 1) {
            setIsAnimating(false);
            setTimeout(() => setCurrentIndex(1), 0);
        }
    };

    ////////////////  background image slide End  ////////////////
    ///////////////////////////////////////////////////////////////

    const [currentIndexs, setCurrentIndexs] = useState(0);

    const totalSlides = 2; // Number of .fifthdiv elements
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndexs((prevIndex) => (prevIndex + 1) % totalSlides);
        }, 3000); // Adjust time (3000ms = 3 seconds) as needed
        return () => clearInterval(interval);
    }, [totalSlides]);

    ///////////////////////////////////////////////////////////

    ////////////////////////////scroll nav hide /////////////////
    const [isVisible, setIsVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    const handleScroll = () => {
        const currentScrollY = window.scrollY;

        if (currentScrollY > lastScrollY) {
            // Scrolling down
            setIsVisible(false);
        } else {
            // Scrolling up
            setIsVisible(true);
        }

        setLastScrollY(currentScrollY);
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [lastScrollY]);

    ////////////////////////////scroll nav hide end /////////////////
    return (<>
        <Helmet>
            <title>Sandip electronics  & Automation | Smart Solar Pump Controllers & IoT</title>
            <meta name="description" content="Leading Indian manufacturer of IoT-powered Solar Pump Controllers, Grid-Connected Inverters, and Remote Monitoring Systems (RMS). Advanced automation for smart irrigation and energy." />
            <meta name="keywords" content="Solar Pump Controller, IoT Solar Solutions, Remote Monitoring System, RMS Solar, Solar Inverter India, Sandip electronics  and Automation, Smart Irrigation Controller" />
            <meta property="og:title" content="SEA | Smart Solar Pump Controllers & IoT Automation" />
            <meta property="og:description" content="Transforming agriculture and industry with IoT-enabled solar solutions. Explore our high-efficiency controllers and RMS." />
            <meta property="og:image" content="https://official.seaiot.in/assets/logo-or-product-preview.png" />
            <meta property="og:url" content="https://official.seaiot.in/" />
            <meta property="og:type" content="website" />
            <link rel="canonical" href="https://official.seaiot.in/" />
        </Helmet>
        <div>
            <div className={`AppA ${isVisible ? "visible" : "hidden"}`}>
                {/* <div className="AppA"> */}
                <div className="mylogo">
                    <div className="logo-container">
                        <Link to="/" className="cursor-pointer">
                            <img src={logo} alt="Logo" />
                        </Link>
                    </div>
                </div>
                <div className="bar-container">
                    <Bar1 />
                </div>
            </div>
            <div className="myApp1">
                <div>
                    <div className="frontpage-first"  >
                        <FrontPage />
                    </div>
                    <div className="myApp" >
                        <div className="background-slideshow">
                            <div
                                className="slideshow-wrapper"
                                style={{
                                    transform: `translateX(-${currentIndex * 100}%)`,
                                    transition: isAnimating ? "transform 1.5s ease-in-out" : "none",
                                }}
                                onTransitionEnd={handleTransitionEndd}
                            >
                                {extendedImageData.map((item, index) => (
                                    <div className={`image-overlay-container slide-${index}`} key={index}>
                                        <img src={item.src} alt={item.alt} className="logo" />
                                        <div className="text-third">
                                            <div className="overlay-text">
                                                <div className="third">
                                                    <div className="circle1">
                                                        <div className={`circle${item.circle || ""}`} ></div>
                                                    </div>
                                                    <div className={`Single-Phase ${item.SinglePhase || ""}`}>
                                                        <img src={item.circleover} alt={item.alt} className="logo1" />
                                                    </div>
                                                </div>
                                                <div className={`overlay-text1 ${item.textClass || ""}`}>
                                                    <h5 className={`overlay-texth5 ${item.overlaytexth5 || ""}`}>{item.heading}</h5>
                                                    <h6 className={`overlay-texth6 ${item.overlaytexth6 || ""}`}>{item.subheading}</h6>
                                                    <div className={`overlay-textSpan ${item.overlaytextSpan || ""}`}>
                                                        <span
                                                            className={`spantext ${item.spantext || ""}`}
                                                            dangerouslySetInnerHTML={{ __html: item.spanText }}
                                                        />
                                                    </div>
                                                    <div className={`overlay-textp ${item.overlaytextp || ""}`}>
                                                        <p
                                                            className=""
                                                            dangerouslySetInnerHTML={{ __html: item.description }}
                                                        />
                                                    </div>
                                                    <div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="devider">
                </div>

                <div className="" >
                    <ProductCategory />
                </div>

                <div className="forthdiv1 flex flex-col ">
                    <div className="hsupport" >
                        <RevealBlurFX>
                            <div className="serviceRow">
                                <h2 className="hrs">
                                    <PointerGradientText lable={"24h"} />
                                </h2>
                                <div className="service-divv-2">
                                    <div className="service">
                                        <PointerGradientText lable={"Support Services"}>
                                        </PointerGradientText>
                                    </div>
                                    <div className="service_paragraph">
                                        Instant Assistance – We're Here for You!
                                        We understand the importance of timely and reliable  support,which is whyour Quick Support service ensures that help is always within reach. Whether you need technical assistance, product guidance, or general inquiries, our dedicated team is ready to assist you.
                                    </div>
                                </div>
                            </div>
                        </RevealBlurFX>

                        <div className="forthdiv1img">
                            <img src={supportgirl} className="supportnow" style={{ height: '100%', width: '650px' }} />
                        </div>
                    </div>

                </div>

                <div class='banner'>
                    <p className="gap-20 bannertxt">
                        {/* <sup><img src={Quotup} className="Pumps" alt="quot" style={{ height: '10px', width: '10px' }} /></sup> */}
                        " Service to ManKind "
                        {/* <sub><img src={Quotdown} className="Pumps" alt="quot" style={{ height: '11px', width: '10px', marginTop: '15px' }} /></sub> */}
                    </p>
                </div>

                <div>
                    {/* <Myanimation/> */}
                </div>

                <div className="mtparagraph">
                    <div className="mtparagraph1">
                    </div>
                </div>

                <SecondAnimate />
                <div style={{ marginTop: '-160px' }}>
                    <WhyUs />
                </div>
                <Footer />
            </div>
        </div>
    </>
    );
}

export default FPage;
